// Set version number and date in the environment.store.ts file

export const environment = {
  production: false,
  baseUrl: 'https://program-api-dev-akeeencqa6bvdpfd.westus2-01.azurewebsites.net',
  context: 'dev',
  maxEffectiveDateDays: 120,
};
